import { SEATS, nextSeat, trickWinnerSeat, scoreHand } from "./setbackRules";

// Plays a hand to completion from a given (possibly mid-hand) state using a
// per-seat `policy(seat, hand, trick, trickSuit, trump)` callback, and
// returns the final scoreHand() result. Deep-clones its inputs so repeated
// calls (as used by search.js/bidding.js) never share mutable state.
const playOutHand = ({
  hands,
  trump,
  trickSuitInit = "",
  trickInit = [],
  wonTricksInit = { teamA: [], teamB: [] },
  trickCountInit = 0,
  toActSeat,
  winningBid,
  policy,
  // Defaults to 4 so 2v2 Teams / 4-player Cutthroat callers (which don't
  // pass this) are unaffected. For 3-player Cutthroat this bounds the
  // simulated trick at 3 cards instead of 4, and keeps nextSeat's
  // wraparound from ever handing a simulated turn to the nonexistent P4 -
  // without it, the extra phantom "4th" pick from an empty hand produced
  // an undefined card that crashed trickWinnerSeat below.
  numPlayers = 4,
}) => {
  const workingHands = {};
  for (const seat of SEATS) {
    workingHands[seat] = hands[seat].map((card) => ({
      ...card,
      details: { ...card.details },
    }));
  }

  let trick = trickInit.slice();
  let trickSuit = trickSuitInit;
  const wonTricks = {
    teamA: wonTricksInit.teamA.slice(),
    teamB: wonTricksInit.teamB.slice(),
  };
  let trickCount = trickCountInit;
  let toAct = toActSeat;

  while (trickCount < 6) {
    while (trick.length < numPlayers) {
      const hand = workingHands[toAct];
      const chosen = policy(toAct, hand, trick, trickSuit, trump);
      workingHands[toAct] = hand.filter((card) => card !== chosen);
      if (trick.length === 0) trickSuit = chosen.suit;
      trick.push(chosen);
      toAct = nextSeat(toAct, numPlayers);
    }

    const winnerSeat = trickWinnerSeat(trick, trickSuit);
    const team = winnerSeat === "P1" || winnerSeat === "P3" ? "teamA" : "teamB";
    wonTricks[team] = wonTricks[team].concat(trick);
    trickCount += 1;
    trick = [];
    trickSuit = "";
    toAct = winnerSeat;
  }

  return scoreHand(wonTricks, winningBid);
};

export { playOutHand };
